import { Card, Form, Row, Col, Button } from "react-bootstrap";
import React, { useState, useRef, useCallback } from "react";
import CustomStore from "devextreme/data/custom_store";
import DataGrid, {
    Column,
    Pager,
    Paging,
    Scrolling,
    Summary,
    TotalItem,
    SearchPanel,
} from "devextreme-react/data-grid";
import notistack from "modules/core/notistack";
import { GetCustomerEarningHistory } from "./services/RewardHistory.services";
import { HasPermission } from "Layout/Permissions/permissionsCache";

const RewardHistory = () => {
    const [phone, setPhone] = useState("");
    const [phoneError, setPhoneError] = useState<string | false>(false);
    const [trigger, setTrigger] = useState(0); // just to reload CustomStore
    const dataGridRef = useRef<DataGrid>(null);

    const dataSource = new CustomStore({
        key: "salesOrderId",
        load: async () => {
            if (!phone || phone.length !== 10) {
                return { data: [], totalCount: 0 };
            }
            try {
                const res = await GetCustomerEarningHistory(phone);
                if (res.status === 200) {
                    return {
                        data: res.data || [],
                        totalCount: res.data?.length || 0,
                    };
                }
                if (res.status === 400) {
                    setPhoneError(
                        res.data?.message ||
                        "This number is not assigned to any customer. Please enter a valid number."
                    );
                    return { data: [], totalCount: 0 };
                }
            } catch (error) {
                console.error("handleCheckPhone error", error);
                notistack.error("Something went wrong while verifying phone");
                return { data: [], totalCount: 0 };
            }
            return { data: [], totalCount: 0 };
        },
    });

    const handleCheckPhone = async () => {
        if (phone.length !== 10) {
            setPhoneError("Please enter a valid 10-digit phone number.");
            return;
        }

        setPhoneError(false);
        // trigger reload
        setTrigger((prev) => prev + 1);
        dataGridRef.current?.instance.refresh();
    };


    const formatDateToIST = (utcDateString: string): string => {
        if (!utcDateString) return "";
        // Ensure it's parsed as UTC
        const date = new Date(utcDateString + "Z");
        return new Intl.DateTimeFormat("en-IN", {
            timeZone: "Asia/Kolkata", // Force IST
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true, // 12h format with AM/PM
        })
            .format(date)
            .replace(",", ""); // remove comma for clean look
    };


    return (
        <Card style={{ paddingTop: "4rem", margin: "0.5rem" }}>
            <h4 className="text-start mb-4">Reward History</h4>

            {HasPermission("Referral.Write") &&
                <>
                    <Row className="mb-3">
                        <Col md={3}>
                            <Form.Control
                                style={{ height: "2rem", marginTop: "0.4rem" }}
                                placeholder="Phone No"
                                maxLength={10}
                                value={phone}
                                onChange={(e) => {
                                    setPhone(e.target.value);
                                    setPhoneError(false);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && phone.length === 10) {
                                        handleCheckPhone();
                                    }
                                }}
                            />
                            {phoneError && <small style={{ color: "red" }}>{phoneError}</small>}
                        </Col>
                        {/* <Col md="auto">
                    <Button className="btn submit-btn mt-2" onClick={handleCheckPhone}>
                        Search
                    </Button>
                </Col> */}
                    </Row>

                    <DataGrid
                        key={trigger}
                        dataSource={dataSource}
                        remoteOperations={{ groupPaging: true }}
                        keyExpr="salesOrderId"
                        showBorders={true}
                        columnAutoWidth={true}
                        ref={dataGridRef}
                        className="mb-3"
                        onCellPrepared={(e) => {
                            if (["data", "header"].includes(e.rowType)) {
                                e.cellElement.style.textAlign = "center";
                            }
                        }}
                    >
                        <Scrolling mode="standard"
                            useNative={true}
                            scrollByContent={true}
                            scrollByThumb={true} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 25, 50, 100]}
                            showNavigationButtons={true}
                            displayMode="full"
                            showInfo={true}
                        />
                        <Summary>
                            <TotalItem />
                        </Summary>
                        <Paging defaultPageSize={10} />


                        <Column dataField="billNo" caption="Bill No." />
                        <Column dataField="name" caption="Customer Name" />
                        <Column dataField="salesOrderId" caption="Sales Order Id" />
                        <Column dataField="transactionType" caption="Transaction Type" />
                        <Column dataField="earningType" caption="Earning Type" />
                        <Column dataField="points" caption="Points"
                            calculateCellValue={(rowData: any) => {
                                if (rowData.transactionType === "Earn") {
                                    return `+${rowData.points}`;
                                }
                                if (rowData.transactionType === "Redeem") {
                                    return `-${rowData.points}`;
                                }
                                return rowData.points;
                            }}
                        />                <Column dataField="amountConverted" caption="Amount Converted" format="#,##0.00" />
                        <Column dataField="totalAmount" caption="Total Amount" format="#,##0.00" />
                        <Column dataField="createdOn" caption="Start Date" dataType="date"
                            // calculateDisplayValue={(rowData) => formatDateToIST(rowData.createdOn)}
                            format="dd/MM/yyyy"
                        />
                        <Column dataField="expiryDate" caption="Expire Date" dataType="date"
                            format="dd/MM/yyyy"

                        // calculateDisplayValue={(rowData) => formatDateToIST(rowData.expiryDate)}

                        />
                    </DataGrid>
                </>
            }
        </Card>
    );
};

export default RewardHistory;
